function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6098 2.19512C25.6098 0.574368 25.0354 0 23.4146 0H6.58538C4.96463 0 4.39026 0.574368 4.39026 2.19512V7.3171H25.6098V2.19512Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5366 3.65852C27.7284 3.65852 27.0732 4.3137 27.0732 5.12192V8.7805H2.92685V5.12199C2.92685 4.31377 2.27168 3.65859 1.46346 3.65859C0.655176 3.65852 0 4.31377 0 5.12199V10.9756C0 11.7838 0.655176 12.439 1.46339 12.439H2.19512V14.6341H4.39025V12.439H25.6098V14.6341H27.8049V12.439H28.5271C29.3375 12.4407 29.9964 11.786 30 10.9756V5.12199C30 4.31377 29.3448 3.65852 28.5366 3.65852Z",
  fill: "#1442A8"
});

var SvgCleanCouch = function SvgCleanCouch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCleanCouch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clean_couch.bc676f77.svg";
export { ForwardRef as ReactComponent };